import { render, staticRenderFns } from "./FrontendFuncParameterList.vue?vue&type=template&id=2519d711&scoped=true&"
import script from "./FrontendFuncParameterList.vue?vue&type=script&lang=ts&"
export * from "./FrontendFuncParameterList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2519d711",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2519d711')) {
      api.createRecord('2519d711', component.options)
    } else {
      api.reload('2519d711', component.options)
    }
    module.hot.accept("./FrontendFuncParameterList.vue?vue&type=template&id=2519d711&scoped=true&", function () {
      api.rerender('2519d711', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FrontendFuncParameterList.vue"
export default component.exports